import React, { createContext, useContext, useState, ReactNode } from 'react';
import ToastNotification, { ToastType } from 'components/common/ToastNotification';

interface ToastState {
    show: boolean;
    message: any;
    type: ToastType;
}

interface ToastContextType {
    showToast: (message: any, type: ToastType) => void;
    hideToast: () => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

interface ToastProviderProps {
    children: ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
    const [toast, setToast] = useState<ToastState>({
        show: false,
        message: null,
        type: "error",
    });

    const showToast = (message: any, type: ToastType) => {
        setToast({
            show: true,
            message,
            type,
        });
    };

    const hideToast = () => {
        setToast((prev) => ({ ...prev, show: false }));
    };

    return (
        <ToastContext.Provider value={{ showToast, hideToast }}>
            {children}
            <ToastNotification
                show={toast.show}
                type={toast.type}
                message={toast.message}
                onClose={hideToast}
            />
        </ToastContext.Provider>
    );
};

export const useToast = (): ToastContextType => {
    const context = useContext(ToastContext);
    if (context === undefined) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
}; 